import { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { GetGraphQlData } from '../../actions/dataQueries'

import generateDocument from './document'

const graphqlVariables = {
  tokenGet: process.env.REACT_APP_TOKEN_GET,
  tokenMutation: process.env.REACT_APP_TOKEN_MUTATION
}

const PrintInvoice = () => {
  const history = useHistory()
  const params = useParams()
  const rtl = useSelector(state => state.ChangeLayoutMode?.rtlData)
  const id = params.id
  const invoiceId = id.toString().padStart(7, '0')
  graphqlVariables.id = id

  const [loadData, setLoadData] = useState(false)
  const [serviceItems, setServiceItems] = useState()
  const [service, setService] = useState()

  useEffect(() => {
    setLoadData(true)
  }, [])
  const graphQlData = GetGraphQlData(graphqlVariables, loadData)
  // getServiceActions vracia { records, total }. Predtym sa tu citalo
  // servicesData[0], cize tlac faktury ostala prazdna.
  const servicesData = graphQlData[0]?.data?.getServiceActions?.records
  if (servicesData !== undefined) {
    setLoadData(false)
    setService(servicesData[0])
    setServiceItems(servicesData[0]?.items)
  }
  return generateDocument(
    serviceItems,
    service,
    invoiceId,
    'print',
    history,
    graphqlVariables,
    rtl
  )
}

export default PrintInvoice
